import { connect } from "react-redux";
import TimesheetTable from "../timesheets/TimesheetTable";
import { PlusCircleIcon } from "@heroicons/react/20/solid";
import { Actions as ACTIONS } from "@/store/actions/timesheetActions";
import InvalidPermissions from "../company-pages/InvalidPermissions";

const EmployeeTimesheets = ({ userPermissions, timesheetSetOpenModal }) => {
	if (userPermissions == "None") return <InvalidPermissions />;
	return (
		<>
			<div className="content mb-5">
				{userPermissions != "Read" && (
					<div
						className="btn btn-success pull-right"
						onClick={() => timesheetSetOpenModal(true, null, "employeeTimesheets")}
					>
						<PlusCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<div style={{ float: "left" }}>Add Time Entry</div>
					</div>
				)}
			</div>
			<TimesheetTable location="employeeTimesheets" />
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		userPermissions: state?.permissions?.my?.permissions?.timesheets,
	};
};

const mapDispatchToProps = (dispatch) => ({
	timesheetSetOpenModal: (status, timesheet, location) =>
		dispatch(ACTIONS.timesheetSetOpenModal(status, timesheet, location)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeTimesheets);
